<div id="layout" class="theme-cyan">
  <app-project-leftmenu></app-project-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body: -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container-fluid">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="avatar sm">
                  <a [routerLink]="['/app-project-overview']" href="javascript:void(0)" title="" class="link"><i
                      class="zmdi zmdi-arrow-left zmdi-hc-lg"></i></a>
                </div>
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Create new project</h5>
                  </div>
                  <small class="text-truncate text-muted">Description text here...</small>
                </div>
              </div>
            </div>

            <!-- page action  -->
            <div class="col-7 col-xl-8 text-end">

            </div>

          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container-fluid">

          <!-- Project: Account-->
          <div class="row">
            <div class="col-12">
              <div class="card mb-4">
                <div class="card-body">

                  <!-- Project: add input-->
                  <form>
                    <div class="form-group row">
                      <label class="col-sm-2 col-form-label">Project code</label>
                      <div class="col-sm-10">
                        <div class="input-group input-group-lg">
                          <input type="text" class="form-control" placeholder="Enter text here">
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-sm-2 col-form-label">Project name</label>
                      <div class="col-sm-10">
                        <div class="input-group input-group-lg">
                          <input type="text" class="form-control" placeholder="Enter text here">
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-sm-2 col-form-label">Start date</label>
                      <div class="col-sm-10">
                        <div class="input-group input-group-lg">
                          <input type="text" class="form-control project-date" placeholder="Start date" bsDatepicker>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-sm-2 col-form-label">Due date</label>
                      <div class="col-sm-10">
                        <div class="input-group input-group-lg">
                          <input type="text" class="form-control project-date" placeholder="Due date" bsDatepicker>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-sm-2 col-form-label">Select Team</label>
                      <div class="col-sm-10">
                        <div class="input-group input-group-lg">
                          <select class="custom-select form-control">
                            <option selected>Select Team</option>
                            <option value="1">One</option>
                            <option value="2">Two</option>
                            <option value="3">Three</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-sm-2 col-form-label">Enter Project Bio</label>
                      <div class="col-sm-10">
                        <textarea rows="4" class="form-control mb-3" placeholder="Enter Project Bio"></textarea>
                        <button type="button" class="btn btn-primary">Create</button>
                        <button type="button" class="btn btn-link">Cancel</button>
                      </div>
                    </div>
                  </form>

                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
